import { Component, Input, OnInit } from '@angular/core';
import Enumerable from 'linq';
import { CorteDiarioModel } from '../corte-diario.models';
import * as moment from 'moment';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ModalEventosComponent } from '../modal-eventos/modal-eventos.component';

@Component({
  selector: 'graph-grid-switch',
  templateUrl: './graph-grid-switch.component.html',
  styleUrls: ['./graph-grid-switch.component.css'],
})
export class GraphGridSwitchComponent implements OnInit {
  constructor(public dialog: MatDialog) {}
  public listGrid: Array<CorteDiarioModel.ListGridExpandibleGraph> = [];
  @Input()
  public listGestiones: Array<CorteDiarioModel.GetGestionesAbiertasXRutas> = [];

  ngOnInit(): void {
    //this.listGrid.push(
    //  {
    //    Expandible: false, Descripcion: 'Eventos', Origen: '0', Transito1: '0', Frontera: '10', Transito2: '5', Destino: '0',
    //    ListGrid2: [
    //      { Descripcion: 'Tipo Evento 1', Origen: 'white', Transito1: 'white', Frontera: '#43A047', Transito2: 'white', Destino: 'white'},
    //      { Descripcion: 'Tipo Evento 2', Origen: 'white', Transito1: 'white', Frontera: 'white', Transito2: '#66BB6A', Destino: 'white'},
    //      { Descripcion: 'Tipo Evento 3', Origen: 'white', Transito1: 'white', Frontera: '#81C784', Transito2: 'white', Destino: 'white'},
    //      { Descripcion: 'Tipo Evento 4', Origen: 'white', Transito1: 'white', Frontera: '#A5D6A7', Transito2: 'white', Destino: 'white' },
    //    ]
    //  },
    //  {
    //    Expandible: false, Descripcion: 'Alertas', Origen: '0', Transito1: '0', Frontera: '10', Transito2: '0', Destino: '0',
    //  },
    //  {
    //    Expandible: false, Descripcion: 'Incidencias', Origen: '0', Transito1: '0', Frontera: '10', Transito2: '0', Destino: '0',
    //  },
    //  {
    //    Expandible: false, Descripcion: 'Casos', Origen: '0', Transito1: '0', Frontera: '10', Transito2: '0', Destino: '0',
    //  }
    //)
  }

  showGestionesAsociadas(itemE: any) {
    // Verificar si el item tiene gestiones ya filtradas (de las celdas de color)
    if (itemE.GestionesAsociadas && itemE.GestionesAsociadas.length > 0) {
      // Si viene de clic en celda de color, usar las gestiones ya filtradas
      this.MostrarEventosPorTipoConGestionesFiltradas(
        itemE.Descripcion,
        itemE.GestionesAsociadas
      );
    } else {
      // Si viene de clic en el nombre del evento, usar todas las gestiones (comportamiento original)
      this.MostrarEventosPorTipo(itemE.Descripcion);
    }
  }

  MostrarEventosPorTipoConGestionesFiltradas(
    eventoTipoDescripcion: string,
    gestionesFiltradas: any[]
  ) {
    const listEventos = [];
    const eventosCerrados = [];
    const eventosAbiertos = [];

    // Recorrer solo las gestiones filtradas
    gestionesFiltradas.forEach((gestion) => {
      // Eventos de gestión principal del tipo específico
      if (gestion.Eventos) {
        gestion.Eventos.forEach((evento) => {
          if (evento.EventoTipo?.Descripcion === eventoTipoDescripcion) {
            // Obtener nombre del sitio o segmento
            const sitioNombre = this.obtenerNombreSitioOSegmento(
              evento,
              gestion
            );
            listEventos.push({
              ...evento,
              SitioNombre: sitioNombre, // Asignar el nombre obtenido
              NumeroGestion: gestion.NumeroGestion,
              EsGestionHija: false,
            });
          }
        });
      }

      // Eventos de gestiones hijas del tipo específico
      if (gestion?.GestionesHijas?.length > 0) {
        gestion.GestionesHijas.forEach((hija) => {
          if (hija.Eventos) {
            hija.Eventos.forEach((evento) => {
              if (evento.EventoTipo?.Descripcion === eventoTipoDescripcion) {
                // Obtener nombre del sitio o segmento
                const sitioNombre = this.obtenerNombreSitioOSegmento(
                  evento,
                  hija
                );
                listEventos.push({
                  ...evento,
                  SitioNombre: sitioNombre, // Asignar el nombre obtenido
                  NumeroGestion: hija.NumeroGestion,
                  EsGestionHija: true,
                });
              }
            });
          }
        });
      }
    });

    // Separar en abiertos y cerrados (código existente)
    listEventos.forEach((event) => {
      if (event.Estado == 'Cerrado') {
        eventosCerrados.push(event);
      } else if (event.Estado == 'Abierto') {
        eventosAbiertos.push(event);
      }
    });

    const listEventosCerrados = Enumerable.from(eventosCerrados)
      .select((evento) => ({
        CreatedDate: moment(evento.CreatedDate).format('DD-MM-YYYY HH:mm'),
        SitioNombre: evento.SitioNombre,
        DisplayName: evento.EventoTipo?.Categoria?.DisplayName,
        Tipo: evento.EventoTipo?.Descripcion,
        Inicio: moment(evento.Inicio).format('DD-MM-YYYY HH:mm'),
        Fin: moment(evento.Fin).format('DD-MM-YYYY HH:mm'),
        CreatedByNombre: evento.CreatedByNombre,
        NumeroGestion: evento.NumeroGestion,
        EsGestionHija: evento.EsGestionHija,
      }))
      .toArray();

    const listEventosAbiertos = Enumerable.from(eventosAbiertos)
      .select((evento) => ({
        CreatedDate: moment(evento.CreatedDate).format('DD-MM-YYYY HH:mm'),
        SitioNombre: evento.SitioNombre,
        DisplayName: evento.EventoTipo?.Categoria?.DisplayName,
        Tipo: evento.EventoTipo?.Descripcion,
        Inicio: moment(evento.Inicio).format('DD-MM-YYYY HH:mm'),
        Fin: moment(evento.Fin).format('DD-MM-YYYY HH:mm'),
        CreatedByNombre: evento.CreatedByNombre,
        NumeroGestion: evento.NumeroGestion,
        EsGestionHija: evento.EsGestionHija,
      }))
      .toArray();

    // Abrir modal con los eventos filtrados
    this.EventModalEventosPorTipo(
      eventoTipoDescripcion,
      listEventos,
      listEventosCerrados,
      listEventosAbiertos,
      gestionesFiltradas
    );
  }

  // Nuevo método para obtener eventos específicos por tipo
  getEventosByTipo(eventoTipoDescripcion: string): any[] {
    const eventosDelTipo = [];

    this.listGestiones.forEach((gestion) => {
      // Eventos de gestión principal
      if (gestion.Eventos?.length > 0) {
        gestion.Eventos.forEach((evento) => {
          if (evento.EventoTipo?.Descripcion === eventoTipoDescripcion) {
            eventosDelTipo.push({
              ...evento,
              NumeroGestion: gestion.NumeroGestion,
              EsGestionHija: false,
            });
          }
        });
      }

      // Eventos de gestiones hijas
      if (gestion.GestionesHijas?.length > 0) {
        gestion.GestionesHijas.forEach((gestionHija) => {
          if (gestionHija.Eventos?.length > 0) {
            gestionHija.Eventos.forEach((evento) => {
              if (evento.EventoTipo?.Descripcion === eventoTipoDescripcion) {
                eventosDelTipo.push({
                  ...evento,
                  NumeroGestion: gestionHija.NumeroGestion, // Número de la gestión hija
                  EsGestionHija: true,
                });
              }
            });
          }
        });
      }
    });

    return eventosDelTipo;
  }

  // Método para agrupar eventos por gestión
  groupEventosByGestion(eventos: any[]): { [key: string]: any[] } {
    return eventos.reduce((acc, evento) => {
      if (!acc[evento.NumeroGestion]) {
        acc[evento.NumeroGestion] = [];
      }
      acc[evento.NumeroGestion].push(evento);
      return acc;
    }, {});
  }
  getGestionesByEventoTipo(eventoTipoDescripcion: string): any[] {
    const gestionesConEsteEvento = [];

    this.listGestiones.forEach((gestion) => {
      let countEventosPrincipal = 0;
      let countEventosHijas = 0;

      // Contar eventos en gestión principal
      if (gestion.Eventos?.length > 0) {
        countEventosPrincipal = gestion.Eventos.filter(
          (evento) => evento.EventoTipo?.Descripcion === eventoTipoDescripcion
        ).length;
      }

      // Contar eventos en gestiones hijas
      if (gestion.GestionesHijas?.length > 0) {
        countEventosHijas = gestion.GestionesHijas.reduce((total, hija) => {
          return (
            total +
            (hija.Eventos?.filter(
              (evento) =>
                evento.EventoTipo?.Descripcion === eventoTipoDescripcion
            ).length || 0)
          );
        }, 0);
      }

      const totalEventos = countEventosPrincipal + countEventosHijas;

      if (totalEventos > 0) {
        gestionesConEsteEvento.push({
          ...gestion,
          EventosEsteTipo: totalEventos,
          EventosPrincipal: countEventosPrincipal,
          EventosHijas: countEventosHijas,
        });
      }
    });

    return gestionesConEsteEvento;
  }

  limitText(text: string, maxLength: number = 20): string {
    if (!text) return '';
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
  }

  ngGenerateSectionInfoGraph() {
    if (this.listGestiones.length > 0) {
      this.listGrid = [];

      const getAllEventosWithContext = () => {
        const eventosWithContext = [];

        this.listGestiones.forEach((gestion) => {
          // Eventos de la gestión principal
          if (gestion.Eventos?.length > 0) {
            gestion.Eventos.forEach((evento) => {
              eventosWithContext.push({
                evento,
                segmentacion: gestion.Segmentacion,
                esGestionHija: false,
              });
            });
          }

          // Eventos de gestiones hijas
          if (gestion.GestionesHijas?.length > 0) {
            gestion.GestionesHijas.forEach((gestionHija) => {
              if (gestionHija.Eventos?.length > 0) {
                gestionHija.Eventos.forEach((evento) => {
                  eventosWithContext.push({
                    evento,
                    segmentacion: gestionHija.Segmentacion, // ← Usar segmentación de la gestión hija
                    esGestionHija: true,
                  });
                });
              }
            });
          }
        });

        return eventosWithContext;
      };

      const eventosWithContext = getAllEventosWithContext();
      const hasEventos = eventosWithContext.length > 0;

      if (hasEventos) {
        let sumInOrigen = 0;
        let sumInT1 = 0;
        let sumInT2 = 0;
        let sumInFrontera = 0;
        let sumInDestino = 0;

        eventosWithContext.forEach(({ evento, segmentacion }) => {
          evento.TipoSitioActual = [];

          if (
            segmentacion?.Origen &&
            evento?.SitioId == segmentacion.Origen?.SitioId
          ) {
            sumInOrigen += 1;
            evento.TipoSitioActual.push('Origen');
          }

          if (segmentacion?.Destino?.length > 0) {
            const enDestino = segmentacion.Destino.some(
              (d) => evento?.SitioId == d?.SitioId
            );
            if (enDestino) {
              sumInDestino += 1;
              evento.TipoSitioActual.push('Destino');
            }
          }

          if (segmentacion?.TransitoUno?.length > 0) {
            const enTransitoUno = segmentacion.TransitoUno.some(
              (tuno) =>
                evento?.SitioId == tuno?.SitioDestino ||
                evento?.SitioId == tuno?.SitioOrigen ||
                evento?.SegmentoId == tuno?.SitioDestino ||
                evento?.SegmentoId == tuno?.SitioOrigen ||
                evento?.SegmentoId == tuno?.SegmentoId
            );
            if (enTransitoUno) {
              sumInT1 += 1;
              evento.TipoSitioActual.push('TransitoUno');
            }
          }

          if (segmentacion?.Frontera?.length > 0) {
            const enFrontera = segmentacion.Frontera.some(
              (f) => evento?.SitioId == f?.SitioId
            );
            if (enFrontera) {
              sumInFrontera += 1;
              evento.TipoSitioActual.push('Frontera');
            }
          }

          if (segmentacion?.TransitoDos?.length > 0) {
            const enTransitoDos = segmentacion.TransitoDos.some((tdos) => {
              return (
                evento?.SitioId == tdos?.SitioOrigen ||
                evento?.SitioId == tdos?.SitioDestino ||
                evento?.SegmentoId == tdos?.SitioOrigen ||
                evento?.SegmentoId == tdos?.SitioDestino ||
                evento?.SegmentoId == tdos?.SegmentoId
              );
            });

            if (enTransitoDos) {
              sumInT2 += 1;
              evento.TipoSitioActual.push('TransitoDos');
            }
          }
        });

        // Agrupamos por descripción del tipo de evento en lugar de ID
        let groupByTipoEvento = Enumerable.from(eventosWithContext)
          .groupBy(({ evento }) => evento.EventoTipo?.Descripcion)
          .toArray();

        let listGrid2: Array<any> = [];

        groupByTipoEvento.forEach((group) => {
          let eventoGrupo = group.getSource().map((x) => x.evento);
          let eventoTipoDescripcion = group.key();

          let cantOrigen = 0;
          let cantTUno = 0;
          let cantTDos = 0;
          let cantFrontera = 0;
          let cantDestino = 0;

          cantOrigen = Enumerable.from(eventoGrupo)
            .where((s) => s.TipoSitioActual?.includes('Origen'))
            .toArray().length;

          cantTUno = Enumerable.from(eventoGrupo)
            .where((s) => s.TipoSitioActual?.includes('TransitoUno'))
            .toArray().length;

          cantTDos = Enumerable.from(eventoGrupo)
            .where((s) => s.TipoSitioActual?.includes('TransitoDos'))
            .toArray().length;

          cantFrontera = Enumerable.from(eventoGrupo)
            .where((s) => s.TipoSitioActual?.includes('Frontera'))
            .toArray().length;

          cantDestino = Enumerable.from(eventoGrupo)
            .where((s) => s.TipoSitioActual?.includes('Destino'))
            .toArray().length;

          listGrid2.push({
            Descripcion: eventoTipoDescripcion,
            Origen: { Cantidad: cantOrigen.toString(), Color: 'white' },
            Transito1: { Cantidad: cantTUno.toString(), Color: 'white' },
            Frontera: { Cantidad: cantFrontera.toString(), Color: 'white' },
            Transito2: { Cantidad: cantTDos.toString(), Color: 'white' },
            Destino: { Cantidad: cantDestino.toString(), Color: 'white' },
            GestionesAsociadas: this.getGestionesByEventoTipo(
              eventoTipoDescripcion
            ),
          });
        });

        // Asignación de colores según la frecuencia (mismo que antes)
        let everyORigen = Enumerable.from(listGrid2)
          .select((s) => Number(s.Origen.Cantidad))
          .toArray()
          .sort((a, b) => b - a);

        let arraywithColors = this.generateOpacidadColorEventos(everyORigen);

        listGrid2.forEach((segmento) => {
          let finItemColor = arraywithColors.find(
            (s) => s.Cantidad == segmento.Origen.Cantidad
          )?.Color;

          if (finItemColor) {
            segmento.Origen.Color = finItemColor;
          }
        });

        let everyFrontera = Enumerable.from(listGrid2)
          .select((s) => Number(s.Frontera.Cantidad))
          .toArray()
          .sort((a, b) => b - a);

        arraywithColors = this.generateOpacidadColorEventos(everyFrontera);

        listGrid2.forEach((segmento) => {
          let finItemColor = arraywithColors.find(
            (s) => s.Cantidad == segmento.Frontera.Cantidad
          )?.Color;

          if (finItemColor) {
            segmento.Frontera.Color = finItemColor;
          }
        });

        let everyT1 = Enumerable.from(listGrid2)
          .select((s) => Number(s.Transito1.Cantidad))
          .toArray()
          .sort((a, b) => b - a);

        arraywithColors = this.generateOpacidadColorEventos(everyT1);

        listGrid2.forEach((segmento) => {
          let finItemColor = arraywithColors.find(
            (s) => s.Cantidad == segmento.Transito1.Cantidad
          )?.Color;

          if (finItemColor) {
            segmento.Transito1.Color = finItemColor;
          }
        });

        let everyT2 = Enumerable.from(listGrid2)
          .select((s) => Number(s.Transito2.Cantidad))
          .toArray()
          .sort((a, b) => b - a);

        arraywithColors = this.generateOpacidadColorEventos(everyT2);

        listGrid2.forEach((segmento) => {
          let finItemColor = arraywithColors.find(
            (s) => s.Cantidad == segmento.Transito2.Cantidad
          )?.Color;

          if (finItemColor) {
            segmento.Transito2.Color = finItemColor;
          }
        });

        let everyDestino = Enumerable.from(listGrid2)
          .select((s) => Number(s.Destino.Cantidad))
          .toArray()
          .sort((a, b) => b - a);

        arraywithColors = this.generateOpacidadColorEventos(everyDestino);

        listGrid2.forEach((segmento) => {
          let finItemColor = arraywithColors.find(
            (s) => s.Cantidad == segmento.Destino.Cantidad
          )?.Color;

          if (finItemColor) {
            segmento.Destino.Color = finItemColor;
          }
        });

        // Agregamos la sección de eventos a listGrid
        this.listGrid.push({
          Expandible: false,
          Descripcion: 'Eventos',
          Origen: {
            Cantidad: sumInOrigen.toString(),
          },
          Transito1: {
            Cantidad: sumInT1.toString(),
          },
          Frontera: {
            Cantidad: sumInFrontera.toString(),
          },
          Transito2: {
            Cantidad: sumInT2.toString(),
          },
          Destino: {
            Cantidad: sumInDestino.toString(),
          },
          ListGrid2: listGrid2,
        });
      }
    }
  }

  generateOpacidadColorEventos(arraySort: number[]) {
    let newItemwithColor = { Cantidad: '', Color: '#' };
    let arrayReturn: Array<CorteDiarioModel.ValuesBYSitio> = [];
    let max = arraySort[0];
    let opacidad = 1;
    arraySort.forEach((item, i) => {
      opacidad = item / max;

      //de mayor a menor
      if (i == 0 && item != 0) {
        //el primero siuempre tiene el color total
        arrayReturn.push({
          Cantidad: item.toString(),
          Color: 'rgb(67, 160, 71)',
        });
      } else if (item == 0) {
        arrayReturn.push({ Cantidad: item.toString(), Color: 'white' });
      } else {
        arrayReturn.push({
          Cantidad: item.toString(),
          Color: `rgb(67, 160, 71,${opacidad} )`,
        });
      }
    });
    return arrayReturn;
  }

  obtenerNombreSitioOSegmento(evento: any, gestion: any): string {
    // Si tiene SitioId, buscar el nombre del sitio
    if (evento.SitioId) {
      const sitio = this.buscarSitioPorId(evento.SitioId, gestion);
      return sitio?.Nombre || 'Sitio desconocido';
    }

    // Si tiene SegmentoId, buscar el nombre del segmento
    if (evento.SegmentoId) {
      const segmento = this.buscarSegmentoPorId(evento.SegmentoId, gestion);
      return segmento?.Nombre || 'Segmento desconocido';
    }

    return 'Ubicación no especificada';
  }

  buscarSitioPorId(sitioId: string, gestion: any): any {
    // Buscar en la ruta
    if (gestion.Ruta?.SitiosPorRuta) {
      return gestion.Ruta.SitiosPorRuta.find((s: any) => s.Id === sitioId);
    }

    // Buscar en la segmentación
    const segmentacion = gestion.Segmentacion;
    const todosLosSitios = [
      segmentacion?.Origen,
      ...(segmentacion?.Destino || []),
      ...(segmentacion?.TransitoUno || []),
      ...(segmentacion?.Frontera || []),
      ...(segmentacion?.TransitoDos || []),
    ].filter((s) => s);

    return todosLosSitios.find((s: any) => s.SitioId === sitioId);
  }

  buscarSegmentoPorId(segmentoId: string, gestion: any): any {
    const segmentacion = gestion.Segmentacion;
    const todosLosSegmentos = [
      ...(segmentacion?.TransitoUno || []),
      ...(segmentacion?.TransitoDos || []),
    ].filter((s) => s);

    return todosLosSegmentos.find(
      (s: any) => s.SegmentoId === segmentoId || s.Id === segmentoId
    );
  }

  MostrarEventosPorTipo(eventoTipoDescripcion: string) {
    const listEventos = [];
    const eventosCerrados = [];
    const eventosAbiertos = [];
    const gestionesConEsteEvento = []; // Nuevo array para almacenar las gestiones

    // Recorrer todas las gestiones para encontrar eventos del tipo específico
    this.listGestiones.forEach((gestion) => {
      let tieneEvento = false;

      // Eventos de gestión principal del tipo específico
      if (gestion.Eventos) {
        gestion.Eventos.forEach((evento) => {
          if (evento.EventoTipo?.Descripcion === eventoTipoDescripcion) {
            // Obtener nombre del sitio o segmento
            const sitioNombre = this.obtenerNombreSitioOSegmento(
              evento,
              gestion
            );
            listEventos.push({
              ...evento,
              SitioNombre: sitioNombre, // Asignar el nombre obtenido
              NumeroGestion: gestion.NumeroGestion,
              EsGestionHija: false,
            });
            tieneEvento = true;
          }
        });
      }

      // Eventos de gestiones hijas del tipo específico
      if (gestion?.GestionesHijas?.length > 0) {
        gestion.GestionesHijas.forEach((hija) => {
          if (hija.Eventos) {
            hija.Eventos.forEach((evento) => {
              if (evento.EventoTipo?.Descripcion === eventoTipoDescripcion) {
                // Obtener nombre del sitio o segmento
                const sitioNombre = this.obtenerNombreSitioOSegmento(
                  evento,
                  hija
                );
                listEventos.push({
                  ...evento,
                  SitioNombre: sitioNombre, // Asignar el nombre obtenido
                  NumeroGestion: hija.NumeroGestion,
                  EsGestionHija: true,
                });
                tieneEvento = true;
              }
            });
          }
        });
      }

      // Si la gestión tiene eventos de este tipo, la agregamos al array
      if (tieneEvento) {
        gestionesConEsteEvento.push(gestion);
      }
    });

    // Separar en abiertos y cerrados
    listEventos.forEach((event) => {
      if (event.Estado == 'Cerrado') {
        eventosCerrados.push(event);
      } else if (event.Estado == 'Abierto') {
        eventosAbiertos.push(event);
      }
    });

    const listEventosCerrados = Enumerable.from(eventosCerrados)
      .select((evento) => ({
        CreatedDate: moment(evento.CreatedDate).format('DD-MM-YYYY HH:mm'),
        SitioNombre: evento.SitioNombre,
        DisplayName: evento.EventoTipo?.Categoria?.DisplayName,
        Tipo: evento.EventoTipo?.Descripcion,
        Inicio: moment(evento.Inicio).format('DD-MM-YYYY HH:mm'),
        Fin: moment(evento.Fin).format('DD-MM-YYYY HH:mm'),
        CreatedByNombre: evento.CreatedByNombre,
        NumeroGestion: evento.NumeroGestion,
        EsGestionHija: evento.EsGestionHija,
      }))
      .toArray();

    const listEventosAbiertos = Enumerable.from(eventosAbiertos)
      .select((evento) => ({
        CreatedDate: moment(evento.CreatedDate).format('DD-MM-YYYY HH:mm'),
        SitioNombre: evento.SitioNombre,
        DisplayName: evento.EventoTipo?.Categoria?.DisplayName,
        Tipo: evento.EventoTipo?.Descripcion,
        Inicio: moment(evento.Inicio).format('DD-MM-YYYY HH:mm'),
        Fin: moment(evento.Fin).format('DD-MM-YYYY HH:mm'),
        CreatedByNombre: evento.CreatedByNombre,
        NumeroGestion: evento.NumeroGestion,
        EsGestionHija: evento.EsGestionHija,
      }))
      .toArray();

    // Abrir modal con los eventos filtrados por tipo
    this.EventModalEventosPorTipo(
      eventoTipoDescripcion,
      listEventos,
      listEventosCerrados,
      listEventosAbiertos,
      gestionesConEsteEvento // Pasar las gestiones al método
    );
  }

  EventModalEventosPorTipo(
    eventoTipoDescripcion: string,
    listEventos: any[],
    listEventosCerrados: any[],
    listEventosAbiertos: any[],
    gestionesConEsteEvento: any[]
  ) {
    const dialogRef = this.dialog.open(ModalEventosComponent, {
      width: '90%',
      height: '90%',
      disableClose: true,
      data: {
        // Para indicar que es el caso múltiple (eventos por tipo)
        esPorTipoEvento: true,
        eventoTipo: eventoTipoDescripcion,

        // Datos para el caso múltiple
        listEventos: listEventos,
        listEventosCerrados: listEventosCerrados,
        listEventosAbiertos: listEventosAbiertos,
        totalEventos: listEventos.length,
        eventosAbiertos: listEventosAbiertos.length,
        eventosCerrados: listEventosCerrados.length,

        // Para mantener compatibilidad con el caso individual
        gestionSelected: null, // No hay gestión específica
      },
    });

    dialogRef.afterClosed().subscribe((result) => {});
  }

  // Método para mostrar gestiones en la modal al hacer clic en las celdas de color
  mostrarGestionesEnModal(itemE: any, segmento: string) {
    const gestiones = this.obtenerGestionesPorEventoYSegmento(
      itemE.Descripcion,
      segmento
    );

    if (gestiones.length > 0) {
      // Crear un objeto similar al que espera showGestionesAsociadas pero con las gestiones filtradas
      const itemFiltrado = {
        ...itemE,
        GestionesAsociadas: gestiones, // Sobrescribir con las gestiones filtradas por segmento
      };

      console.log(
        'Gestiones filtradas para',
        itemE.Descripcion,
        'en',
        segmento,
        ':',
        gestiones
      );

      // Llamar al método existente que abre la modal
      this.showGestionesAsociadas(itemFiltrado);
    } else {
    }
  }

  // Método para obtener gestiones por tipo de evento y segmento
  obtenerGestionesPorEventoYSegmento(
    eventoTipo: string,
    segmento: string
  ): any[] {
    const gestionesEncontradas = new Set<any>();
    const segmentoMapeado = this.mapearSegmentoParaEvento(segmento);

    this.listGestiones.forEach((gestion) => {
      // Buscar en eventos principales
      if (gestion.Eventos?.length > 0) {
        const tieneEvento = gestion.Eventos.some(
          (evento) =>
            evento.EventoTipo?.Descripcion === eventoTipo &&
            evento.TipoSitioActual?.includes(segmentoMapeado)
        );

        if (tieneEvento) {
          gestionesEncontradas.add(gestion);
        }
      }

      // Buscar en gestiones hijas
      if (gestion.GestionesHijas?.length > 0) {
        gestion.GestionesHijas.forEach((gestionHija) => {
          if (gestionHija.Eventos?.length > 0) {
            const tieneEventoHija = gestionHija.Eventos.some(
              (evento) =>
                evento.EventoTipo?.Descripcion === eventoTipo &&
                evento.TipoSitioActual?.includes(segmentoMapeado)
            );

            if (tieneEventoHija) {
              gestionesEncontradas.add(gestionHija);
            }
          }
        });
      }
    });

    return Array.from(gestionesEncontradas);
  }

  // Mapear nombres de segmento para coincidir con TipoSitioActual
  mapearSegmentoParaEvento(segmento: string): string {
    const mapeo = {
      Origen: 'Origen',
      Transito1: 'TransitoUno',
      Transito2: 'TransitoDos',
      Frontera: 'Frontera',
      Destino: 'Destino',
    };
    return mapeo[segmento] || segmento;
  }
}
